import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import isNull from 'lodash/isNull';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedName } from '../../../../../../../../onboarding-business-insight.types';
import { EMPTY_VALUE } from '../../../../../../constants';
type MobileRowProps = {
  businessName: FormattedName;
  onOpen: (id: string) => void;
};
const MobileRow = t0 => {
  const $ = _c(36);
  const {
    businessName: t1,
    onOpen
  } = t0;
  const {
    name,
    sources,
    sourceSOSFilingId,
    submitted,
    verified,
    kind
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  let t3;
  if ($[1] !== kind || $[2] !== t) {
    t3 = () => {
      if (kind === "dba") {
        return t(_temp);
      }
      if (kind === "legal") {
        return t(_temp2);
      }
      return EMPTY_VALUE;
    };
    $[1] = kind;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getKindText = t3;
  let t4;
  if ($[4] !== submitted || $[5] !== t) {
    t4 = submitted ? t(_temp3) : t(_temp4);
    $[4] = submitted;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const submittedText = t4;
  let t5;
  if ($[7] !== getKindText) {
    t5 = getKindText();
    $[7] = getKindText;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== submitted || $[10] !== submittedText) {
    t6 = isNull(submitted) ? EMPTY_VALUE : submittedText;
    $[9] = submitted;
    $[10] = submittedText;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== sources || $[13] !== t) {
    t7 = sources === EMPTY_VALUE ? EMPTY_VALUE : t(_temp5, {
      sources
    });
    $[12] = sources;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = [t5, t6, t7].filter(_temp6);
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const details = t8;
  let t9;
  if ($[19] !== name) {
    t9 = <span className="min-w-0 text-label-2 text-primary wrap-anywhere">{name}</span>;
    $[19] = name;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t || $[22] !== verified) {
    t10 = !isNull(verified) && <Badge className="shrink-0" variant={verified ? "success" : "error"}>{verified ? t(_temp7) : t(_temp8)}</Badge>;
    $[21] = t;
    $[22] = verified;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <span className="flex items-start justify-between gap-3">{t9}{t10}</span>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== details) {
    t12 = details.length > 0 && <span className="text-body-3 text-tertiary wrap-anywhere">{details.map(_temp9)}</span>;
    $[27] = details;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const content = t13;
  let t14;
  if ($[32] !== content || $[33] !== onOpen || $[34] !== sourceSOSFilingId) {
    t14 = <td>{sourceSOSFilingId ? <button className="flex w-full cursor-pointer flex-col gap-0.5 py-2 text-left whitespace-normal" onClick={() => onOpen(sourceSOSFilingId)} type="button">{content}</button> : <div className="flex flex-col gap-0.5 py-2 whitespace-normal">{content}</div>}</td>;
    $[32] = content;
    $[33] = onOpen;
    $[34] = sourceSOSFilingId;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default MobileRow;
function _temp($) {
  return $.businessDetails.name.table.dba;
}
function _temp2($_0) {
  return $_0.businessDetails.name.table.legal;
}
function _temp3($_1) {
  return $_1.businessShared.tags.submitted;
}
function _temp4($_2) {
  return $_2.businessShared.tags.notSubmitted;
}
function _temp5($_3) {
  return $_3.businessDetails.name.table.source;
}
function _temp6(detail) {
  return detail !== EMPTY_VALUE;
}
function _temp7($_4) {
  return $_4.businessShared.tags.verified;
}
function _temp8($_5) {
  return $_5.businessShared.tags.notVerified;
}
function _temp9(detail_0, index) {
  return <Fragment key={detail_0}>{index > 0 && " \xB7 "}<span className="inline-block">{detail_0}</span></Fragment>;
}